import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap";
import { post, put } from "../../../helpers/api_helper";
import { toast } from "react-toastify";

// availity-reactstrap-validation

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../../components/Common/Breadcrumb";
import Utils from "../../Utility";

// actions

import Table from "./Table";
import Loader from "../../../components/Loader";
import {
  AvCheckbox,
  AvCheckboxGroup,
  AvField,
  AvForm,
} from "availity-reactstrap-validation";
import moment from "moment";
import { useHistory } from "react-router-dom";
const Property = (props) => {
  const { user } = props;
  const history = useHistory();
  const [isAddForm, setIsAddForm] = useState(false);
  const [isTable, setIsTable] = useState(true);
  const [currentData, setCurrentData] = useState(null);
  const [currentData1, setCurrentData1] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [singleId, setSingleId] = useState(null);
  const [file, setFile] = useState(null);
  const [dateType, setDateType] = useState(true);
  const [newsPannel, setNewsPannel] = useState(false);
  const formRef = useRef(null);
  // console.log("add tender page props", props, typeof moment(currentData?.valid_till).format('DD-MM-YYYY') ,moment(currentData?.valid_till).format('DD-MM-YYYY'));

  const onChangeFile = (event) => {
    // Handle file change logic here
    console.log("File changed:", event.target.files);
  };

  useEffect(() => {
    if (props?.location?.state) {
      setCurrentData(props?.location?.state?.row);
      setDateType(false);
    }
  }, [props?.location?.state]);

  const handleValidSubmit = async (e, v) => {
    let body = {
      ...v,
    };
    if (formRef.current) {
      formRef.current.reset();
    }
    console.log("Form Submitted", body);
    // setLoading(true);
    // return;
    // if (file.substring(0, 4) == "blob") {
    //   const fileData = cropper?.current?.cropper
    //     ?.getCroppedCanvas()
    //     .toDataURL();
    //   const obj = await urltoFile(
    //     fileData,
    //     new Date().getTime() + ".webp",
    //     "image/webp"
    //   );
    //   const temp = await resizeFile(obj);
    //   const form = new FormData();
    //   form.append("image", temp);
    //   const imageRes = await upload("/tender/image_upload", form);
    //   body = { ...body, pdf: imageRes?.data };
    // }
    if (currentData) {
      body = { ...body, newsId: currentData?._id };
      put("/news", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            history.goBack();
            // setIsAddForm(false);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    } else {
      post("/news", body)
        .then((res) => {
          setLoading(false);
          if (res?.statusCode == 200) {
            toast.success(res?.message);
            console.log("res from tender", res);
          } else {
            toast.error(res?.error);
          }
        })
        .catch((err) => {
          toast.error(err);
          setLoading(false);
        });
    }
  };

  const disPlayNews = (e) => {
    console.log("add news panel", e?.target?.checked);
    setNewsPannel(e.target.checked);
  };

  return (
    <>
      <div className="page-content">
        <Loader visible={loading} />
        {/* Render Breadcrumb */}
        <Breadcrumb
          title={Utils.projectName}
          breadcrumbItem={currentData ? `Update Tender!` : `Add New Tender`}
        />

        <div className="main-box-form main_box_form_all">
          <div className="table_top_header">
            <CardTitle className="h4">
              <i class="mdi mdi-pencil"></i> Add nesw{" "}
            </CardTitle>
          </div>
          <Card style={{ borderRadius: "0" }}>
            <CardBody>
              <AvForm
                ref={formRef}
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  console.log("Form data submitted:", v);
                  handleValidSubmit(e, v, "bank");
                }}
              >
                <Row>
                  <Col lg={6} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="name"
                        label="News Title *"
                        className="form-control"
                        placeholder=""
                        type="text"
                        required
                        value={currentData?.name}
                      />
                    </div>
                  </Col>
                  <Col lg={6} md={12}>
                    <div className="mb-3">
                      <AvField
                        name="link"
                        label="Link *"
                        className="form-control"
                        placeholder=""
                        type="text"
                        required
                        value={currentData?.link}
                      />
                    </div>
                  </Col>
                  <Col lg={12} md={12}>
                    <div className="form-group mb-4">
                      <AvField
                        name="description"
                        label="Description *"
                        className="form-control"
                        placeholder=""
                        type="textarea"
                        required
                        value={currentData?.description}
                      />
                    </div>
                  </Col>
                  <br />
                </Row>
                <div className="mt-4">
                  <Row>
                    {currentData && (
                      <Col md={6}>
                        <button
                          className="btn btn-primary w-100 waves-effect waves-light"
                          style={{
                            backgroundColor: Utils.themeColor1,
                            border: "none",
                          }}
                          onClick={() => {
                            history.goBack();
                          }}
                          type="reset"
                        >
                          Cancel
                        </button>
                      </Col>
                    )}
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        type="submit"
                        style={{
                          backgroundColor: Utils.themeColor,
                          border: "none",
                        }}
                      >
                        {currentData ? "Update" : "Submit"}
                      </button>
                    </Col>
                  </Row>
                </div>
              </AvForm>
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

Property.propTypes = {
  getProfile: PropTypes.func,
  error: PropTypes.any,
  success: PropTypes.any,
  companyError: PropTypes.func,
  companySuccess: PropTypes.func,
  createCompany: PropTypes.func,
  updateCompany: PropTypes.func,
};

const mapStatetoProps = (state) => {
  const { user } = state.Profile;
  console.log("user mat", user);
  const { company } = state.Company;
  return { user, company };
};

export default withRouter(connect(mapStatetoProps, {})(Property));
